import * as types from './types';
import { loading, success, handleErrorException } from 'State/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const getTruckRoute = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_TRUCK_ROUTE_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`TruckRoute/GetTruckRoutes`);
      dispatch(success(types.GET_TRUCK_ROUTE_LIST, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route list. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_TRUCK_ROUTE_LIST_LOADING_ERROR,
          defaultError
        )
      );
    }
    dispatch(loading(types.GET_TRUCK_ROUTE_LIST_LOADING, false));
  };
};
export const clearTruckRouteErrors = () => {
  return {
    type: types.CLEAR_TRUCK_ROUTE_LIST_ERROR,
  };
};
export const printTruckRouteDetail = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_TRUCK_ROUTE_DETAIL_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TruckRoute/GetTruckRouteSummaryReport/${id}`
      );
      if (response.data.Data) {
        const data = response.data.Data;
        if (data) ReportGeneration(data, 'Truck Route Print');
      }
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while creating PDF. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.PRINT_TRUCK_ROUTE_DETAIL_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.PRINT_TRUCK_ROUTE_DETAIL_LOADING, false));
    }
  };
};
export const deleteTruckRoute = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.DELETE_TRUCK_ROUTE_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TruckRoute/DeleteTruckRoute/${id}`
      );
      dispatch(success(types.DELETE_TRUCK_ROUTE, response.data));
      dispatch(getTruckRoute());
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while deleting truck route. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.DELETE_TRUCK_ROUTE_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.DELETE_TRUCK_ROUTE_LOADING, false));
    }
  };
};

export const clearDeleteTruckRouteSuccess = () => {
  return {
    type: types.CLEAR_DELETE_TRUCK_ROUTE_SUCCESS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteslist/actions.js